import Media from './Media';

export {
  Media,
};
